var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxHeartFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4703 3.19277C13.1027 2.82258 12.6656 2.5287 12.184 2.32803C11.7025 2.12735 11.186 2.02384 10.6643 2.02344C9.67753 2.0236 8.72678 2.39429 8.00031 3.0621C7.27391 2.39417 6.32312 2.02347 5.33631 2.02344C4.81401 2.02398 4.29696 2.12781 3.81494 2.32895C3.33291 2.53009 2.89542 2.82457 2.52765 3.19544C0.958979 4.77077 0.959646 7.23477 2.52898 8.80344L8.00031 14.2748L13.4716 8.80344C15.041 7.23477 15.0416 4.77077 13.4703 3.19277V3.19277Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxHeartFilled);
export default __webpack_public_path__ + "static/media/bx-heart-filled.f8b0f523037422c8004256ca0fef812b.svg";
export { ForwardRef as ReactComponent };